// 智能体：列表、读一个、新建、更新（服务端整份替换 config：先取完整的，改几项，再整份送回）、删除。
import { request } from './client'
import type { Agent } from './types'

export const getAgent = (id: string) => request<{ data: Agent }>(`/agents/${encodeURIComponent(id)}`).then((r) => r.data)
export const createAgent = (a: { name: string; description: string; config: Agent['config'] }) => request<{ data: Agent }>('/agents', { body: a }).then((r) => r.data)
export const updateAgent = (id: string, a: { name: string; description: string; avatar?: string; config: Agent['config'] }) =>
  request<{ data: Agent }>(`/agents/${encodeURIComponent(id)}`, { method: 'PUT', body: a }).then((r) => r.data)
export const deleteAgent = (id: string) => request(`/agents/${encodeURIComponent(id)}`, { method: 'DELETE' })
